// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './PintrestIcon.style';

export class PintrestIcon extends PureComponent {
    static propTypes = {
        // TODO: implement prop-types
    };

    render() {
        return (
            <svg width="19" height="26" viewBox="0 0 19 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1279_449)">
                    <path d="M3.73303 15.6138C4.03853 15.7362 4.31101 15.6138 4.40183 15.2873C4.45963 15.0587 4.60826 14.471 4.67431 14.2261C4.76514 13.8915 4.73211 13.7772 4.4844 13.4915C3.94771 12.863 3.60092 12.0549 3.60092 10.904C3.60092 7.56559 6.12752 4.57814 10.1734 4.57814C13.7569 4.57814 15.7303 6.74118 15.7303 9.63885C15.7303 13.4425 14.0294 16.6586 11.4945 16.6586C10.0991 16.6586 9.05046 15.5158 9.38899 14.1119C9.79358 12.4386 10.5697 10.6347 10.5697 9.42663C10.5697 8.34918 9.98349 7.44315 8.76973 7.44315C7.34128 7.44315 6.19358 8.90423 6.19358 10.8632C6.19358 12.1121 6.62294 12.9528 6.62294 12.9528C6.62294 12.9528 5.16147 19.0746 4.9055 20.1521C4.39358 22.2906 4.83119 24.9026 4.86422 25.172C4.88899 25.3271 5.08716 25.3679 5.17798 25.2454C5.31009 25.074 7.01101 23.0008 7.58899 20.9275C7.75413 20.3398 8.53028 17.2952 8.53028 17.2952C8.99266 18.1686 10.3468 18.944 11.7917 18.944C16.0853 18.944 19 15.075 19 9.89189C19 5.96575 15.6477 2.31714 10.545 2.31714C4.20367 2.31714 1 6.81464 1 10.5694C1 12.8385 1.86697 14.8628 3.73303 15.6138Z" fill="#FDF8F4" />
                </g>
                <defs>
                    <clipPath id="clip0_1279_449">
                        <rect width="19" height="25" fill="white" transform="translate(0 0.817139)" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default PintrestIcon;
